module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Fishing-6191224f2527a22750d8283d70ce740f.png";